import { render, staticRenderFns } from "./ProductBottomLine.vue?vue&type=template&id=6e284315&scoped=true&lang=pug"
import script from "./ProductBottomLine.vue?vue&type=script&lang=js"
export * from "./ProductBottomLine.vue?vue&type=script&lang=js"
import style0 from "./ProductBottomLine.vue?vue&type=style&index=0&id=6e284315&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e284315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e284315')) {
      api.createRecord('6e284315', component.options)
    } else {
      api.reload('6e284315', component.options)
    }
    module.hot.accept("./ProductBottomLine.vue?vue&type=template&id=6e284315&scoped=true&lang=pug", function () {
      api.rerender('6e284315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductBottomLine.vue"
export default component.exports